import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {put, takeLatest, select} from 'redux-saga/effects'
import {UserModel} from '../models/UserModel'
import {getUserByToken} from './AuthCRUD'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  Login: '[Login] Action',
  Logout: '[Logout] Action',
  Register: '[Register] Action',
  UserRequested: '[Request User] Action',
  UserLoaded: '[Load User] Auth API',
  SetUser: '[Set User] Action',
  RestoreSessionFromStorage: '[Auth] Restore session from storage',
}

const initialAuthState: IAuthState = {
  user: undefined,
  accessToken: undefined,
  responseModal: undefined,
  // secureToken:undefined
}

export interface IAuthState {
  user?: UserModel
  accessToken?: string
  responseModal?: UserModel
  // secureToken?:string
}

var strleftmenu = ''

export const reducer = persistReducer(
  // Persist JWT alongside user so refresh keeps the session (axios reads accessToken).
  {storage, key: 'user-info', whitelist: ['user', 'accessToken']},
  (state: IAuthState = initialAuthState, action: ActionWithPayload<IAuthState>) => {
    switch (action.type) {
      case actionTypes.Login: {
        let responseData = action.payload?.responseModal
        const accessToken = responseData?.token || 'error';
        localStorage.setItem("authToken", accessToken);
        localStorage.setItem("token", accessToken);
        // let responseData = action.payload?.responseModal
        // const accessToken = "MyToken88";
        // let configList = "My configs";
        // localStorage.setItem("configs", configList);
        return {user: responseData, accessToken: accessToken}
      }

      // case actionTypes.Register: {
      //   const accessToken = action.payload?.accessToken
      //   return {accessToken, user: undefined}
      // }

      case actionTypes.Logout: {
        localStorage.clear();
        return initialAuthState
      }

      case actionTypes.UserLoaded: {
        const user = action.payload?.user
        return {...state, user}
      }

      case actionTypes.SetUser: {
        const user = action.payload?.user
        return {...state, user}
      }

      case actionTypes.RestoreSessionFromStorage: {
        if (state.accessToken && state.accessToken !== 'error') {
          return state
        }
        const token =
          typeof window !== 'undefined'
            ? localStorage.getItem('token') || localStorage.getItem('authToken')
            : null
        if (token && token !== 'error') {
          return {...state, accessToken: token}
        }
        return state
      }

      default:
        return state
    }
  }
)

export const actions = {
  login: (responseModal: UserModel) => ({
    type: actionTypes.Login,
    payload: {responseModal},
  }),
  register: (accessToken: string) => ({
    type: actionTypes.Register,
    payload: {accessToken},
  }),
  logout: () => ({type: actionTypes.Logout}),
  requestUser: () => ({
    type: actionTypes.UserRequested,
  }),
  fulfillUser: (user: UserModel) => ({type: actionTypes.UserLoaded, payload: {user}}),
  setUser: (user: UserModel) => ({type: actionTypes.SetUser, payload: {user}}),
  restoreSessionFromStorage: () => ({type: actionTypes.RestoreSessionFromStorage}),
  store: () => ({type: 'def'}),
}

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser())
  })

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    // @ts-ignore
    const getToken = (state) => state.auth.accessToken
    // @ts-ignore
    let token = yield select(getToken)
    // alert("dispatch api:2")
    // const {data: user} = yield getUserByToken(token)
    // yield put(actions.fulfillUser(user))
  })
}
